<template>
  <NewsletterForm
    v-if="showModal"
    :show-modal="showModal"
    @close-modal="closeModal"
  />
</template>

<script>
import NewsletterForm from '~/components/Common/NewsletterForm/NewsletterForm.vue';
import isMobile from '~/mixins/responsive';
import { useSubscriptionStore } from '~/stores/subscription';

export default {
  components: {
    NewsletterForm,
  },
  data() {
    return {
      showModal: false,
      timer: 35, // seconds
      percentage: 0.1,
      subscriptionStore: null,
    };
  },

  watch: {
    'subscriptionStore.subscribed': function (subscribed) {
      if (subscribed) {
        this.removeEventListeners();
      }
    },
  },
  created() {
    this.subscriptionStore = useSubscriptionStore();
  },
  mounted() {
    if (isMobile) {
      setTimeout(() => {
        if (this.subscriptionStore.subscribed === false) {
          this.showNewsletter();
        }
      }, this.timer * 1000);
    }

    window.addEventListener('mouseout', this.onMouseOut);
  },
  beforeUnmount() {
    this.removeEventListeners();
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    onMouseOut(event) {
      if (!event.toElement && !event.relatedTarget) {
        this.showNewsletter();
      }
    },
    removeEventListeners() {
      window.removeEventListener('mouseout', this.onMouseOut);
    },
    showNewsletter() {
      if (['privacy', 'cookie-policy'].includes(this.$route.name)) {
        return;
      }

      this.showModal = true;
      this.removeEventListeners();
    },
  },
};
</script>
